<template>

    <div class="page-center content-load animated fadeIn">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-xl-offset-4 col-md-6 col-md-offset-3">

                    <div class="login-register-page">

                        <center>
                            <img src="static/images/logo.png" width="180" class="logo margin-bottom-20">
                        </center>                        
                        
                        <div class="welcome-text margin-bottom-30 margin-top-10">
                            <h3 class="margin-bottom-10">
                                <ion-icon name="checkmark-circle-outline"></ion-icon>
                                Cadastro realizado
                            </h3>
                            <span>
                                
                            </span>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                            <div class="dashboard-box margin-top-0 mobile">

                                <div class="content with-padding">

                                    <div class="row">                        
                                        <div class="col-lg-12">
                                            <p class="margin-top-0" style="text-align: center; font-size: 16px; font-weight: 300; color: #000">
                                                Obrigado! O seu <b>cadastro</b> foi <b>realizado</b> com sucesso. Nossa equipe <b>analisará</b> as <b>informações</b> para aprovação do seu cadastro, logo você será <b>notificado</b>.
                                            </p>
                                        </div>  

                                        <div class="col-lg-12 col-xs-12 margin-top-10 margin-bottom-0" style="text-align: center;">
                                                     
                                            <a class=" margin-top-10" v-on:click="$root.logout();" style="opacity: 0.3; width: 100%; text-align: center !important; color: #000 !important">
                                                <ion-icon name="arrow-back-outline"></ion-icon>
                                                Sair
                                            </a>                                    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name:                           'Cadastro3',
    components: {
    },     
    data () {
        var self                    = this;
        return {
            form: {}
        }
    },
    methods: {

    },
    created: function() {
        var self = this;
        self.$root.getUser();
    },
    mounted: function() {
        loading.hide();
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

    .current-page-cadastro3 .loading {
        top: 0px !important;
    }   

    .current-page-cadastro3 {
        background-image: url(/static/images/bg3.png);
        background-size: cover;
        background-repeat: repeat;
        background-position: center;
    }
    .page-cadastro3 #wrapper {
        background: #fe0100 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }   

   
    .page-cadastro3 .container {
        margin-top: 35px !important;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 20px;
    }
    .page-cadastro3 input {
        margin-bottom: 7px;
    }
    .page-cadastro3 .input-with-icon-left i {
        background: transparent;
        border-right: none;
    }
    .page-cadastro3 .input-with-icon-left i {
        color: #fe0100;
    }
    .page-cadastro3 .selo {
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 0px;
        text-transform: uppercase;
        font-size: 10px;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
    .page-cadastro3 .section-headline {
        padding-right: 0px;
    }       
    .page-cadastro3 .button.small.block-mobile ion-icon {
        /*font-size: 30px;*/
    }
    .page-cadastro3 .button.small.block-mobile {
        line-height: 130%;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        background: #fff;
        border: 1px solid #EFEFEF;
        color: #555;
        width: 100%;
    }
    .page-cadastro3 .welcome-text h3 ion-icon {
        color: #fff !important;

    }
    .page-cadastro3 .welcome-text h3 {
        color: #fff !important;
    }

    .current-page-cadastro3 .loading {
        top: 0px !important;
    } 

    .page-cadastro3 input {
        margin-bottom: 5px;
    }
    .page-cadastro3 .input-with-icon-left i {
        background: transparent;
        border-right: none;
    }
    .page-cadastro3 .input-with-icon-left i {
        color: #000;
    }
    .page-cadastro3 .section-headline {
        padding-right: 0px;
    }
    .page-cadastro3 .container.cadastro {
        margin-top: 25px !important;
        padding-left: 20px;
        padding-right: 20px;
        /*margin-bottom: 20px;*/
    }

    .page-cadastro3 .uploadButton-button {
        display: none !important;
    }        
    .page-cadastro3 .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .page-cadastro3 .imagem-preview {
        width: 100%;
        height: 25vh;
        border-radius: 10px;
        margin-bottom: 25px;
        background-size: auto 100%;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }
    
    .page-cadastro3 h5 {
        font-size: 16px;
        line-height: 130%;
        font-weight: 500;
    }

    .page-cadastro3 h5 ion-icon {
        color: green;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cadastro3.vue